/**
 * TrackerGroupFlowTab — the Flow sub-tab for a group whose tracker has the Flow
 * Optimizer: reuses {@link CampaignFlowsTab}, the Flow Optimizer UI of
 * `/campaigns/:id`.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import CampaignFlowsTab from '@/features/campaigns/components/tabs/CampaignFlowsTab';
import { useCampaignFlowsByProvider } from '@/hooks';
import type { CampaignProvider } from '@/hooks/voluum/useVoluum';

import { FlowUnlinkedCard } from './FlowUnlinkedCard';

interface TrackerGroupFlowTabProps {
  provider: CampaignProvider;
  trafficCampaignId: string | null;
}

export const TrackerGroupFlowTab: FC<TrackerGroupFlowTabProps> = ({
  provider,
  trafficCampaignId,
}) => {
  const { data: flows, isLoading } = useCampaignFlowsByProvider(
    trafficCampaignId ?? '',
    provider,
  );

  if (!trafficCampaignId) {
    return <FlowUnlinkedCard tracker={provider} />;
  }

  return (
    <CampaignFlowsTab
      campaignId={trafficCampaignId}
      provider={provider}
      flows={flows ?? []}
      loading={isLoading}
    />
  );
};

export default TrackerGroupFlowTab;
